@if (agreementType === 'ack') {
  <app-agreement-ack></app-agreement-ack>
}
@if (agreementType === 'free-idle-warning') {
  <app-agreement-free-idle-warning></app-agreement-free-idle-warning>
}
